import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserStore } from '../../store';

export default function ApplicationBadge({ jobApplication }) {
  const isClient = useUserStore((state) => state.isClient);
  const { status, subStatus } = jobApplication;
  const { t } = useTranslation();

  const activeInteviewClient = jobApplication?.jobApplicationInterviews?.find(
    (intv) => intv.contactType === 'Client' && intv.status !== 'Canceled'
  );

  const isPastInterviewDateClient =
    new Date(activeInteviewClient?.interviewDate) < new Date();
  const interviewFeedbacks =
    activeInteviewClient?.jobApplicationInterviewFeedbacks?.find(
      (feedback) => feedback.feedbackType === 'Client'
    );
  const hasInterviewFeedbacks = !!interviewFeedbacks;

  if (status === 'ClientSubmit' && subStatus === 'Hire') {
    return isClient ? (
      <span>{t('common.jobApplicationBadge.ClientSubmit.Hire')}</span>
    ) : (
      <span>{t('common.jobApplicationBadge.ClientSubmit.HireRecruiter')}</span>
    );
  }

  if (
    status === 'ClientInterview' &&
    subStatus !== 'Canceled' &&
    subStatus !== 'Requested' &&
    subStatus !== 'ClientRejected' &&
    subStatus !== 'Declined' &&
    subStatus !== 'Rejected' &&
    subStatus !== 'Pending' &&
    isPastInterviewDateClient
  ) {
    if (hasInterviewFeedbacks) {
      return (
        <span>{t('common.jobApplicationBadge.ClientInterview.Completed')}</span>
      );
    }
    return (
      <span>
        {t('common.jobApplicationBadge.ClientInterview.AwaitingFeedback')}
      </span>
    );
  }

  return <span>{t(`common.jobApplicationBadge.${status}.${subStatus}`)}</span>;
}
